// @ts-nocheck
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import icons from '../../../../constants/icons';
import { FormatCamelCaseAsString } from '../../../../util/formatter';
import Button from '../../Button';

const SortableItem = ({
  id,
  column,
  items,
  allColumns,
  onColumnChange,
  onColumnDelete,
}) => {
  const { t } = useTranslation();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <li
      ref={setNodeRef}
      style={style}
      {...attributes}
      className="sortable-item"
    >
      <div {...listeners}>
        <FontAwesomeIcon icon={icons.SORTABLE_HANDLE} className="ms-2 me-5" />
      </div>

      <select
        className="form-control"
        style={{ display: 'inline-block' }}
        defaultValue={column.key}
        onChange={(e) => onColumnChange(e, column)}
      >
        {allColumns
          ?.sort((a, b) => a.localeCompare(b))
          .map((x) => (
            <option value={x} key={x}>
              {FormatCamelCaseAsString(x)}
            </option>
          ))}
      </select>

      <Button
        className="btn btn-default btn-outline ms-3 btn--square"
        isDisabled={items?.length < 2}
        title={items?.length < 2 ? t('Can not remove last item') : t('Remove')}
        onClick={() => onColumnDelete(column)}
        text={t('Remove')}
        icon={icons.DELETE_TAG}
        hideTitle={true}
      />
    </li>
  );
};



export default SortableItem;
